import React, {useState} from 'react';
import { connect } from 'react-redux';
import { update_customer_password, update_supplier_password } from '../../../redux/actions/adminActions';
import Spinner from '../../reusables/spinner';
import InputField from '../../reusables/input';
import { toast } from "react-toastify";

function ResetPassword({ update, updateCustomer, customer, userId, newUser, submit, accessToken, close, create }) {

    const [formData,
        setData] = useState({password: '', password_confirmation: ''})

    const [isLoading,
        setIsLoading] = useState(false);

    const handleChange = (e) => {
        setData({
            ...formData,
            [e.target.name]: e.target.value
        })
    }

    const handleLoading = () => {
        setIsLoading(true);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        handleLoading();
        if(newUser){
            if (formData.password !== formData.password_confirmation){
                toast.error('Confirm password must be the same as password')
            }else if (formData.password.length < 8 ){
                toast.error('Password must be the at least 8 characters')
            }else {
                submit(formData);
            }
        }
        else{
            if(customer){
                updateCustomer(userId, formData, accessToken, close)
            }else{
                update(userId, formData, accessToken, close)
            }
        }
    }

    return (
      <div className="mb-4 container">
        <form className="py-3 px-2" onSubmit={handleSubmit}>
          {newUser ? (
            <>
              <div className="mt-2 mb-2">
                <InputField
                  label="New Password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                />
              </div>

              <div className="mt-2 mb-2">
                <InputField
                  label="Confirm New Password"
                  name="password_confirmation"
                  value={formData.password_confirmation}
                  onChange={handleChange}
                />
              </div>
            </>
          ) : (
            ""
          )}

          <div className="mt-4">
            {isLoading ? (
              <button className="btn__filled textIsBold alignOnly">
                Please Wait <Spinner />
              </button>
            ) : (
              <button className="btn__filled textIsBold">
                {newUser ? "Create Account" : "Send Password Reset Link"}
              </button>
            )}
          </div>
        </form>
      </div>
    );
}

const mapStateToProps = (state) => ({
    accessToken: state.admin.token
})

const mapDispatchToProps = (dispatch) => ({
    update: (id, data, token, success) => dispatch(update_supplier_password(id, data, token, success)),
    updateCustomer: (id, data, token, success) => dispatch(update_customer_password(id, data, token, success))
})

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword)
